/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Reset_Password_DescriptionInputs */

const en_common_sign_reset_password_description = /** @type {(inputs: Common_Sign_Reset_Password_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a new password for your account.`)
};

const zh_common_sign_reset_password_description = /** @type {(inputs: Common_Sign_Reset_Password_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为你的账号设置新密码。`)
};

/**
* | output |
* | --- |
* | "Choose a new password for your account." |
*
* @param {Common_Sign_Reset_Password_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_reset_password_description = /** @type {((inputs?: Common_Sign_Reset_Password_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Reset_Password_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_reset_password_description(inputs)
	return zh_common_sign_reset_password_description(inputs)
});
export { common_sign_reset_password_description as "common.sign.reset_password_description" }